<template>
  <div class="content-with-spacing help-page-container">
    <div class="heading-and-content">
      <div class="heading-container">
        <div class="top-breadcrumb">
          <router-link :to="{ name: 'help' }">Help</router-link>
          <span class="breadcrumb-divider"><i class="fas fa-angle-right"></i></span>
          <a class="current-page">Logging OTJ Hours in EDUKATE</a>
        </div>
      </div>
      <div class="otj-help content-with-spacing">
        <div v-html="markdownContent" v-if="markdownContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';
import { importImage } from '@utils/dynamic-image-importer';
import otjMarkdown from './otj_markdown_doc/otj.md?raw';

export default {
  name: 'OtjGuidance',
  data() {
    return {
      markdownContent: null,
      markdownContentReady: false,
    };
  },
  beforeMount() {
    this.renderMarkdown();
  },
  watch: {
    markdownContentReady(newVal) {
      if (newVal) {
        this.$Loading.finish();
      } else {
        this.$Loading.start();
      }
    },
  },
  methods: {
    renderMarkdown() {
      this.markdownContentReady = false;
      const processedMarkdown = otjMarkdown.replace(
        /!\[([^\]]*)\]\(\/src\/img\/([^)]+)\)/g,
        (match, alt, path) => `![${alt}](${importImage(path)})`,
      );
      this.markdownContent = marked(this.$kpurify.sanitise(processedMarkdown));
      this.markdownContentReady = true;
    },
  },
};
</script>
